<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import ATextarea from '~/components/atoms/forms/BaseTextarea.vue'

interface Props {
  text: string
  textError: string
}

defineProps<Props>()
const emit = defineEmits<{
  (e: 'change-text', value: string): void
  (e: 'cancel-subscribtion'): void
  (e: 'cancel'): void
}>()

const changeText = (value: string): void => {
  emit('change-text', value)
}
const cancelSubscribtion = () => {
  emit('cancel-subscribtion')
}
const cancel = () => {
  emit('cancel')
}

</script>

<template>
  <RModal
    name-modal="cancelSubscribtionModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="subscribeModalLabel"
      >
        Отменить подписку?
      </h5>
    </template>

    <template #body>
      <div class="body">
        <span class="d-block mb-2">
          Жаль, что вы уходите 😢 Поделитесь, что вам
          <br>
          не понравилось, каких функций не хватило?
        </span>
        <ATextarea
          :value="text"
          :placeholder="
            'Мы регулярно улучшаем функционал Magvi и постараемся исправить эту проблему при следующем обновлении'
          "
          :rows="4"
          :error-message="textError"
          @change="changeText"
          @enter="changeText"
        />
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Secondary"
        @click="cancel"
      >
        Нет, оставить
      </AButton>
      <AButton
        :button-style="ButtonStyle.Danger"
        @click="cancelSubscribtion"
      >
        Да, отменить
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  min-height: rem(174px);
  padding-bottom: rem(32px);
}
</style>
